export var CookiesConsentKeys;
(function (CookiesConsentKeys) {
    CookiesConsentKeys["PERFORMANCE"] = "c0002:1";
    CookiesConsentKeys["FUNCTIONAL"] = "c0003:1";
    CookiesConsentKeys["ADVERTISING"] = "c0004:1";
    CookiesConsentKeys["SOCIAL_MEDIA"] = "c0005:1";
})(CookiesConsentKeys || (CookiesConsentKeys = {}));
export const COOKIE_OPTANON_CONSENT = 'OptanonConsent';
export const COOKIE_SAT_TRACK = 'sat_track';
export const ONE_YEAR = 365;
